/**
 * A list of types of locations that input data can be sourced from.
 */
export enum SourceType {
    manualEntry = "ManualEntry",
    restDownload = "RestDownload",
    previousStepOutput = "PreviousStepOutput"
}